/* @todo refactor, can be solved by just by html, css.. but cookie consent is dependent on this also */

export class Checkbox {
  constructor($element) {
    this.$element = $element;
  }

  init = () => {
    this.$element.checkboxInstance = this;

    this.checkboxEl = this.$element.querySelector('[type="checkbox"]');

    this.svgEl = this.$element.querySelector('.checkbox__icon');

    this.state = {
      hovering: false,
      checked: false,
      required: false
    };

    this.$element.addEventListener('mouseenter', this.setHoverState);
    this.$element.addEventListener('mouseleave', this.setHoverState);

    var requiredAttr = this.checkboxEl.required;
    if (typeof requiredAttr !== "undefined" && requiredAttr !== false) {
      this.state.required = true;
      this.setValue(true);
    }
    else {
      // this is not a required checkbox the user can interact with it.
      this.$element.removeEventListener('click', this.onclick);
      this.$element.addEventListener('click', this.onclick);

      // click should be sufficient but this script somehow runs double
      const onKeyUp = (e) => {
        if (e.code === 'Space') {
          this.onclick();
        }
      }
      this.$element.removeEventListener('keyup', onKeyUp);
      this.$element.addEventListener('keyup', onKeyUp);
    }

    // check if this is already checked from the start
    if (this.checkboxEl.checked) {
      this.state.checked = true;
    }
  }

  onclick = () => {
    this.setValue(!this.checkboxEl.checked);
  }

  setHoverState = (ev) => {
    this.state.hovering = ev.type === "mouseenter";
  }

  setValue(value) {
    this.checkboxEl.checked = value;
    this.state.checked = value;
  }

  subscribeOnChange(func) {
    var requiredAttr = this.checkboxEl.required;
    if (typeof requiredAttr === 'undefined' || requiredAttr === false) {
      this.checkboxEl.addEventListener('change', func);
    }
  }
}

const init = () => {
  const $elements = document.querySelectorAll('[data-checkbox]');
  $elements.forEach((el) => new Checkbox(el).init());
}

export default init;